import angular from 'angular';
import debounce from 'lodash/debounce';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'deactivationsTableController',
    ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
      // init variables
      $scope.deactivationsEnableTableActionMenu = false;
      $scope.deactivationsInitialLoad = true;
      $scope.deactivationsIsPageOptions = false;
      $scope.deactivationsIsSortOptions = false;
      $scope.deactivationsIsTableActionMenu = false;
      $scope.deactivationsPageData = {};
      $scope.deactivationsRecords = [];
      $scope.deactivationsShowMoreStatus = {};
      $scope.deactivationsTableLoading = false;

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.generateUserRoute = () => {
        return `${$rootScope.routes.user}/${$scope.user.id}`;
      };

      $scope.deactivationsCheckRangeErrors = async (
        filter_key,
        choice_key,
        date_field,
        submission,
      ) => {
        if (!$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          if (submission) {
            if (
              !$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              $scope.deactivationsTable.filters[key].options.choices[choice_key].error = true;
              return true;
            }
          } else {
            if (
              !$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from ||
              !$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to ||
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from == '' ||
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to == ''
            ) {
              return true;
            }
          }
          if (date_field) {
            var from = moment(
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from,
            ).valueOf();
            var to = moment(
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to,
            ).valueOf();
          } else {
            var from =
              $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from;
            var to = $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to;
          }
          if (to - from < 0) {
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].error = true;
            return true;
          }
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].error = false;
          return false;
        }
      };

      $scope.deactivations_watch_timeframe_range = async (filter_key, choice_key, target) => {
        if (!$scope.deactivationsTable.filters[filter_key].options.choices[choice_key].state) {
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from = '';
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to = '';
        } else {
          const timeframe = await $scope.format_timeframe_range(
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from,
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to,
          );
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from =
            timeframe[0];
          $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to =
            timeframe[1];
          if (
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key][target] &&
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key][target] !== ''
          ) {
            await angular.forEach(
              $scope.deactivationsTable.filters[filter_key].options.choices,
              async (choice, key) => {
                if (key == choice_key) {
                  $scope.deactivationsTable.filters[filter_key].options.choices[key].state = true;
                } else {
                  $scope.deactivationsTable.filters[filter_key].options.choices[key].state = false;
                }
              },
            );
          }
        }
      };
      angular.forEach($scope.deactivationsTable.filters, async (filter, filter_key) => {
        angular.forEach(filter.options.choices, async (choice, choice_key) => {
          if ('from' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
              async () => {
                if (choice.date_field) {
                  await $scope.deactivations_watch_timeframe_range(filter_key, choice_key, 'from');
                }
                var areErrors = await $scope.deactivationsCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
          if ('to' in choice) {
            $scope.$watch(
              `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
              async () => {
                if (choice.date_field) {
                  await $scope.deactivations_watch_timeframe_range(filter_key, choice_key, 'to');
                }
                var areErrors = await $scope.deactivationsCheckRangeErrors(
                  filter_key,
                  choice_key,
                  choice.date_field,
                  false,
                );
              },
            );
          }
        });
      });

      // Angucomplete Filter

      $scope.deactivationsFilterAngucomplete = (query, key) => {
        return $scope
          .angucompleteSearch(
            $http,
            ENV,
            $scope.deactivationsTable.filters[key].options.search_endpoint,
            $scope.deactivationsTable.filters[key].options.search_endpoint_data_key,
            { search: query, autocomplete: true },
          )
          .then((res) => res);
      };

      $scope.deactivationsFilterAngucompletePage = (query, key) => {
        return $scope
          .angucompleteSearchByUrl(
            $http,
            query,
            $scope.deactivationsTable.filters[key].options.search_endpoint_data_key,
          )
          .then((res) => res);
      };

      $scope.deactivationsSetSelectedAngucomplete = (item, key) => {
        $scope.deactivationsTable.filters[key].options.selected.push(item);
      };

      $scope.deactivationsRemoveAngucomplete = (id, key) => {
        $scope.deactivationsTable.filters[key].options.selected = $scope.deactivationsTable.filters[
          key
        ].options.selected.filter((item) => item.id !== id);
      };

      $scope.deactivationsRemoveAllAngucomplete = (key) => {
        $scope.deactivationsTable.filters[key].options.selected = [];
      };

      $scope.deactivations_change_timeframe = async (new_timeframe_choice) => {
        await angular.forEach($scope.deactivationsTable.filters, async (filter, filter_key) => {
          if (filter.options.query_string_parameter == 'timeframe') {
            await angular.forEach(filter.options.choices, async (choice, choice_key) => {
              if (choice.value == new_timeframe_choice) {
                $scope.deactivationsTable.filters[filter_key].options.choices[
                  choice_key
                ].state = true;
              } else {
                $scope.deactivationsTable.filters[filter_key].options.choices[
                  choice_key
                ].state = false;
              }
            });
          }
        });
      };

      // Get Table Data

      $rootScope.getDeactivations = async () => {
        $scope.deactivationsTableLoading = true;
        var parameters = {};
        $scope.deactivationsPageData = {};
        $scope.deactivationsRecords = [];
        await angular.forEach($scope.deactivationsTable.filters, async (filter, key) => {
          if (filter.type == 'multiple_choice') {
            parameters[filter.options.query_string_parameter] = Object.values(
              filter.options.choices,
            )
              .filter((item) => item.state === true)
              .map((item) => item.value)
              .join(',');
            if (
              (!(filter.options.query_string_parameter in parameters) ||
                parameters[filter.options.query_string_parameter] == '') &&
              'no_selected_parameter' in filter.options
            ) {
              parameters[filter.options.query_string_parameter] =
                filter.options.no_selected_parameter;
            }
          }
          if (filter.type == 'multi_level_multiple_choice') {
            var multi_level_selected = [];
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (choice.state === true) {
                if ('options' in choice) {
                  var options = '';
                  await angular.forEach(choice.options, async (level, level_key) => {
                    if (level.state) {
                      options = options + `:${level.value}`;
                    }
                  });
                  if (options !== '') {
                    multi_level_selected.push(`${choice.value}${options}`);
                  }
                }
              }
            });
            if (multi_level_selected.length) {
              parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
            }
          }
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if ('error' in $scope.deactivationsTable.filters[key].options.choices[choice_key]) {
                $scope.deactivationsTable.filters[key].options.choices[choice_key].error = false;
              }
              if (choice.state === true) {
                if (choice.type == 'standard') {
                  parameters[filter.options.query_string_parameter] = choice.value;
                } else if (choice.type == 'amount') {
                  if (!choice.amount || choice.amount == '') {
                    $scope.deactivationsTable.filters[key].options.choices[choice_key].error = true;
                  } else {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.amount}`;
                  }
                } else if (choice.type == 'range') {
                  if (choice.date_field) {
                    const formatted_dates = await $scope.format_timeframe_range(
                      choice.from,
                      choice.to,
                    );
                    var date_from = null;
                    var date_to = null;
                    if (formatted_dates[0] && formatted_dates[0] != '') {
                      var date = moment(formatted_dates[0]);
                      date_from = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[0];
                      $scope.deactivationsTable.filters[key].options.choices[
                        choice_key
                      ].from = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (formatted_dates[1] && formatted_dates[1] != '') {
                      var date = moment(formatted_dates[1]);
                      date_to = date.isValid() ? date.format('YYYY-MM-DD') : formatted_dates[1];
                      $scope.deactivationsTable.filters[key].options.choices[
                        choice_key
                      ].to = date.isValid() ? date.format('YYYY-MM-DD') : null;
                    }
                    if (
                      $scope.deactivationsTable.filters[key].options.choices[choice_key].from &&
                      $scope.deactivationsTable.filters[key].options.choices[choice_key].to
                    ) {
                      var areErrors = await $scope.deactivationsCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `range:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.deactivationsTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  } else {
                    if (choice.to && choice.from) {
                      var areErrors = await $scope.deactivationsCheckRangeErrors(
                        key,
                        choice_key,
                        choice.date_field,
                        true,
                      );
                      if (!areErrors) {
                        parameters[
                          filter.options.query_string_parameter
                        ] = `${choice.value}:${choice.from}:${choice.to}`;
                      }
                    } else {
                      $scope.deactivationsTable.filters[key].options.choices[
                        choice_key
                      ].error = true;
                    }
                  }
                }
              }
            });
          }
          if (filter.type == 'angucomplete' && 'search_endpoint' in filter.options) {
            if (filter.options.selected.length) {
              parameters[filter.options.query_string_parameter] = filter.options.selected
                .map((item) => item.id)
                .join(',');
            }
          }
        });

        var error = false;
        await angular.forEach($scope.deactivationsTable.filters, async (filter, key) => {
          if (filter.type == 'single_choice') {
            await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
              if (
                'error' in $scope.deactivationsTable.filters[key].options.choices[choice_key] &&
                $scope.deactivationsTable.filters[key].options.choices[choice_key].error
              ) {
                error = true;
              }
            });
          }
        });
        if (error) {
          return;
        }

        const sortOptions = [];
        await Object.entries($scope.deactivationsTable.sort_options).forEach(([key, item]) => {
          if (item.state === true) {
            sortOptions.push(item.value === '1' ? key : `-${key}`);
          }
        });
        parameters['order'] = sortOptions.join(',');
        parameters['page_size'] = $scope.deactivationsTable.options.records_per_page;
        $scope
          .getTableData(
            $http,
            ENV,
            $scope.deactivationsTable.options.endpoint,
            $scope.deactivationsTable.options.endpoint_data_key,
            parameters,
          )
          .then((res) => {
            $timeout(async () => {
              if ($scope.deactivationsTable.options.scale_up) {
                if (
                  res.meta.count === 0 &&
                  'timeframe' in parameters &&
                  parameters.timeframe != 'all' &&
                  $scope.deactivationsInitialLoad
                ) {
                  switch (parameters.timeframe) {
                    case 'day':
                      await $scope.deactivations_change_timeframe('week');
                      break;
                    case 'week':
                      await $scope.deactivations_change_timeframe('year');
                      break;
                    case 'year':
                      await $scope.deactivations_change_timeframe('all');
                      break;
                  }
                  return $rootScope.getDeactivations();
                }
              }
              $scope.deactivationsTableLoading = false;
              $scope.deactivationsPageData = res;
              $scope.deactivationsInitialLoad = false;
              $scope.deactivationsShowMoreStatus = {};
              $scope.deactivationsScrollToTop();
            });
          });
      };

      $scope.goTodeactivationsPage = (url) => {
        $scope.deactivationsTableLoading = true;
        $scope.deactivationsPageData = {};
        $scope.deactivationsRecords = [];
        $scope
          .getTableDataByUrl($http, url, $scope.deactivationsTable.options.endpoint_data_key)
          .then((res) => {
            $timeout(() => {
              $scope.deactivationsPageData = res;
              $scope.deactivationsTableLoading = false;
              $scope.deactivationsScrollToTop();
            });
          });
      };

      $scope.deactivationsValidCustomValue = (filter_key, choice_key, key) => {
        if (key === 'amount') {
          $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].amount = $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].amount.replace(/[^0-9\-]+/g, '');
          if (
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].amount ===
              '' ||
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].amount === null
          ) {
            return;
          }
        }
        if (key === 'range') {
          $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].from = $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].from.replace(/[^0-9\-]+/g, '');
          $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].to = $scope.deactivationsTable.filters[filter_key].options.choices[
            choice_key
          ].to.replace(/[^0-9\-]+/g, '');
          if (
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from ===
              null ||
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].from === '' ||
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to === null ||
            $scope.deactivationsTable.filters[filter_key].options.choices[choice_key].to === ''
          ) {
            return;
          }
        }
      };

      $scope.deactivationsClearText = async (filter_key, choice_key) => {
        await angular.forEach(
          $scope.deactivationsTable.filters[filter_key].options.choices,
          async (choice, key) => {
            if (key == choice_key) {
              $scope.deactivationsTable.filters[filter_key].options.choices[key].state = true;
            } else {
              $scope.deactivationsTable.filters[filter_key].options.choices[key].state = false;
              if ('error' in choice) {
                $scope.deactivationsTable.filters[filter_key].options.choices[key].error = false;
              }
              if ('amount' in choice) {
                $scope.deactivationsTable.filters[filter_key].options.choices[key].amount = '';
              }
              if ('from' in choice || 'to' in choice) {
                $scope.deactivationsCheckRangeErrors(
                  filter_key,
                  key,
                  $scope.deactivationsTable.filters[filter_key].options.choices[key].date_field,
                  false,
                );
              }
            }
          },
        );
      };

      $scope.deactivationsSwitchSelectAll = (key, value) => {
        Object.values($scope.deactivationsTable.filters[key].options.choices).forEach((item) => {
          item.state = value;
          if ('options' in item) {
            Object.values(item.options).forEach((option) => {
              option.state = value;
            });
          }
        });
      };

      $scope.deactivationsShowPageOptions = () => {
        $scope.deactivationsIsPageOptions = !$scope.deactivationsIsPageOptions;
      };

      $scope.deactivationsSelectPageOption = (option) => {
        $scope.deactivationsTable.options.records_per_page = option;
      };

      $scope.deactivationsShowSortOptions = () => {
        $scope.deactivationsIsSortOptions = !$scope.deactivationsIsSortOptions;
      };

      $scope.deactivationsSelectSort = async (option_key, value) => {
        await angular.forEach($scope.deactivationsTable.sort_options, async (option, key) => {
          if (key == option_key) {
            $scope.deactivationsTable.sort_options[key].value = value;
            $scope.deactivationsTable.sort_options[key].state = true;
          }
        });
      };

      $scope.deactivationsSelectSortOptions = () => {
        $scope.deactivationsIsSortOptions = false;
      };

      $scope.deactivationsShowSortTitles = () => {
        return Object.values($scope.deactivationsTable.sort_options)
          .filter((item) => item.state === true)
          .map((item) => item.title)
          .join(', ');
      };

      $scope.deactivationsGetChoices = async () => {
        await Promise.all(
          $scope.deactivationsTable.filters.map(async (value, key) => {
            if (
              (value.type == 'multiple_choice' || value.type == 'multi_level_multiple_choice') &&
              'choices_endpoint' in value.options
            ) {
              const choices = await $scope.getTableFilterOptions(
                $http,
                ENV,
                value.options.choices_endpoint,
                value.options.choices_endpoint_data_key,
              );
              if (choices && !!choices.length) {
                await choices.forEach((item) => {
                  var state =
                    ('default_choice' in value.options &&
                      item[value.options.name_attribute] == value.options.default_choice) ||
                    !('default_choice' in value.options)
                      ? true
                      : false;
                  $scope.deactivationsTable.filters[key].options.choices[
                    item[value.options.name_attribute]
                  ] = {
                    state: state,
                    value: item.id,
                  };
                  if ('level' in value.options && value.options.level) {
                    $scope.deactivationsTable.filters[key].options.choices[
                      item[value.options.name_attribute]
                    ]['options'] = angular.copy(value.options.level);
                  }
                });
              }
            }
          }),
        );
        $rootScope.getDeactivations();
      };

      $scope.deactivationsScrollToTop = () => {
        $('deactivations-table .container').scrollTop(0);
        $('deactivations-table .filter-panel').scrollTop(0);
      };

      $(document).on('click', (event) => {
        const pageOptionEle = $('deactivations-table .page-content');
        const sortOptionEle = $('deactivations-table .sort-content');
        const tableActionsEle = $('deactivations-table .table-actions-options');
        const settingEle = $('deactivations-table .header-actions');
        var $target = $(event.target);

        if (settingEle !== event.target && !settingEle.has(event.target).length) {
          $scope.$apply(() => {
            $scope.isDeactivationsActionMenu = false;
          });
        }

        if (
          pageOptionEle !== event.target &&
          !$target.closest('deactivations-table .page-content').length &&
          !pageOptionEle.has(event.target).length
        ) {
          $timeout(() => {
            $scope.deactivationsIsPageOptions = false;
          });
        }
        if (
          sortOptionEle !== event.target &&
          !$target.closest('deactivations-table .sort-content').length &&
          !sortOptionEle.has(event.target).length &&
          $scope.deactivationsIsSortOptions
        ) {
          $timeout(() => {
            $scope.deactivationsIsSortOptions = false;
            $scope.deactivationsSelectSortOptions();
          });
        }
        if (
          tableActionsEle !== event.target &&
          !$target.closest('deactivations-table .table-actions-options').length &&
          !tableActionsEle.has(event.target).length &&
          $scope.deactivationsIsTableActionMenu
        ) {
          $timeout(() => {
            $scope.deactivationsIsTableActionMenu = false;
          });
        }
      });

      $scope.init();

      const deactivationsComponentVisibleListener = $rootScope.$watch('componentOpened', () => {
        if (!$rootScope.componentOpened) {
          $scope.deactivationsEnableTableActionMenu = false;
          $scope.deactivationsInitialLoad = true;
          $scope.deactivationsIsPageOptions = false;
          $scope.deactivationsIsSortOptions = false;
          $scope.deactivationsIsTableActionMenu = false;
          $scope.deactivationsPageData = {};
          $scope.deactivationsRecords = [];
          $scope.deactivationsShowMoreStatus = {};
          $scope.clearDeactivationsDetail();
        }
      });

      $scope.watcherDeactivationsTrigger = () => {
        $scope.setTable();
        if ($rootScope.isDeactivationsDisplay && $rootScope.userId) {
          $scope.deactivationsEnableTableActionMenu = false;
          $scope.deactivationsInitialLoad = true;
          $scope.deactivationsIsPageOptions = false;
          $scope.deactivationsIsSortOptions = false;
          $scope.deactivationsIsTableActionMenu = false;
          $scope.deactivationsPageData = {};
          $scope.deactivationsRecords = [];
          $scope.deactivationsShowMoreStatus = {};
          $scope.deactivationsGetChoices();
          $scope.deactivationsScrollToTop();
        } else {
          $scope.deactivationsEnableTableActionMenu = false;
          $scope.deactivationsInitialLoad = true;
          $scope.deactivationsIsPageOptions = false;
          $scope.deactivationsIsSortOptions = false;
          $scope.deactivationsIsTableActionMenu = false;
          $scope.deactivationsPageData = {};
          $scope.deactivationsRecords = [];
          $scope.deactivationsShowMoreStatus = {};
          $scope.clearDeactivationsDetail();
        }
      };

      const isDeactivationsDisplayListener = $rootScope.$watch('isDeactivationsDisplay', () => {
        $scope.watcherDeactivationsTrigger();
      });

      $scope.$on('$destroy', function () {
        $scope.unsubscribe();
        isDeactivationsDisplayListener();
        deactivationsComponentVisibleListener();
      });
    },
  )
  .directive('deactivationsTable', () => {
    return {
      templateUrl: 'templates/v2/deactivations-table.html',
    };
  });
